(function($) {

	$.fn.zendbox = function() {

		var elem = $(this);

		var init = function() {

	        if (typeof (Zenbox) !== 'undefined') {

	        	// Set the properties
	            Zenbox.init({
	                dropboxID: '20188477',
	                url: 'https://pathwaysoftware.zendesk.com',
	                tabID: 'feedback',
	                tabColor: '#6699ff',
	                tabPosition: 'Right',
	                hide_tab: 'true'
	            });
	        }

	        // Show zendbox on button click
	        elem.on('click', function(evt) {

	        	evt.preventDefault();

	        	Zenbox.show();
	        });
		}

		init();
		return this;
	};

}($));